var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollarC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 309,
    viewBox: "0 0 248 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "CollarDark",
    d: "M101 151.659H96.2559C93.6898 158.146 92.9368 163.43 94.974 169.095C95.4016 168.951 101 167.292 101 167.292V151.659Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Collar",
    d: "M114.781 192.344C117.633 193.103 119.512 193.35 123.499 193.434V194.887C119.106 194.828 116.917 194.545 113.659 193.434C106.122 200.805 102.41 205.542 96.2548 213.777C86.9014 198.608 82.4615 188.796 77 171.5C79.576 170.604 80.2713 170.549 81.3611 169.096C82.4509 167.643 89.7486 155.539 96.2548 151.659C93.6886 158.146 92.9996 163.511 94.9728 169.096C97.3301 175.768 103.487 182.754 114.781 192.344Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "CollarMirroredDark",
    d: "M145.978 151.659H150.746C153.422 158.254 153.965 163.76 151.992 169.345C148.985 168.458 145.978 167.521 145.978 167.521V151.659Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "CollarMirrored",
    d: "M132.221 192.344C129.369 193.103 127.49 193.35 123.503 193.434V194.887C127.896 194.828 130.085 194.545 133.343 193.434C140.88 200.805 144.592 205.542 150.747 213.777C160.101 198.608 164.539 188.796 170 171.5C167.424 170.604 166.731 170.549 165.641 169.096C164.551 167.643 157.253 155.539 150.747 151.659C153.313 158.146 154.002 163.511 152.029 169.096C149.672 175.768 143.515 182.754 132.221 192.344Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollarC);
export default __webpack_public_path__ + "static/media/Collar C.f635d24088b4e8dda892bc369904ee1f.svg";
export { ForwardRef as ReactComponent };